import React, {useState} from "react";
import {Button} from "react-bootstrap";
import {
  handleDishOrderCountAction,
  removeOrderDishesAction,
} from "../../../../store/actions/OrdersActions";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ReactComponent as Cart} from "../../../../icons/cart.svg";
import {ReactComponent as Trash} from "../../../../icons/trash.svg";
import {translateRecord, dishesAmount, isTerminal} from "../../../common/utils";
import BottomModal from "../../../common/BottomModal";
import OrderDish from "./OrderDish";

const BusketOrders = (props) => {
  const storeOrders = useSelector(store => store.orders);
  const storeAuth = useSelector(store => store.auth);
  const storeRestaurant = useSelector(store => store.restaurants);
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const orderDishes = storeOrders.orderDishes;
  const [state, setState] = useState({
    busketOrdersModal: false,
    selectedRestaurant: '',
    selectedCompany: '',
  });

  const dishesCount = () => {
    if (!!props.slug) {
      return Object.values(orderDishes).filter((r) => r.restaurant.slug === props.slug)
        .map((o) => Object.keys(o.dishes).length).reduce((partialSum, a) => partialSum + a, 0)
    } else {
      return Object.values(orderDishes).map((o) => Object.keys(o.dishes).length)
        .reduce((partialSum, a) => partialSum + a, 0)
    }
  };

  function removeDishes(slug) {
    dispatch(removeOrderDishesAction(slug));
  }

  function tableId(slug) {
    if (!!storeRestaurant.restaurants[slug]) {
      if (!!storeRestaurant.restaurants[slug].table) {
        return storeRestaurant.restaurants[slug].table.id
      } else if (![].concat.apply([], Object.keys(orderDishes[slug].restaurant.order_types)
        .filter(o => o !== 'on_table').map((order_type) =>
          Object.values(orderDishes[slug].restaurant.order_types[order_type])))
        .includes(true) && !!orderDishes[slug].restaurant.table) {
        return orderDishes[slug].restaurant.table.id;
      }
    } else {
      return '';
    }
  }

  const companies = () => {
    const companiesMap = {};

    for (const key in orderDishes) {
      const { company } = orderDishes[key];
      if (company && !companiesMap[company.slug]) {
        companiesMap[company.slug] = company;
      }
    }

    return companiesMap;
  };

  const restaurantBusket = (slug) => <>
    { Object.values(storeOrders.orderDishes[slug].dishes).map((dish, index) =>
      <OrderDish dish={dish} slug={slug} fromDashboard={props.fromDashboard} key={index}
         onEmpty={() => setState({...state, selectedRestaurant: Object.keys(orderDishes).filter((s) => s !== slug)[0]})
      }/>)}
    { !!orderDishes[slug].company ?
      <Link className='btn btn-lg btn-primary w-100 mt-2' to={`/check-out/${orderDishes[slug].company.slug}`}
            onClick={() => setState({...state, busketOrdersModal: false})}
      >
        {t('components.menu.toOrder')} <span>{companyDishesAmount()}<small>₴</small></span>
      </Link>
    :
      <>
        { !(!!storeRestaurant.restaurants[slug] && storeRestaurant.restaurants[slug].table) &&
             !orderDishes[slug].restaurant.isSplited && !props.fromDashboard &&
          <Link className='btn btn-lg btn-primary w-100 mt-2' to={`/checkout/${slug}`}
                onClick={() => setState({...state, busketOrdersModal: false})}
          >
            {t('components.menu.toOrder')} <span>{dishesAmount(slug)}<small>₴</small></span>
          </Link>}
      </>}
  </>;

  function openModal() {
    if (!!companies()) {
      setState({...state, selectedCompany: Object.keys(companies())[0], busketOrdersModal: true,
        selectedRestaurant: !!Object.keys(companies())[0] && Object.values(orderDishes)
          .filter((o) => !!o.company && o.company.slug === Object.keys(companies())[0])[0].restaurant.slug})
    } else {
      setState({...state, busketOrdersModal: true})
    }
  }

  function companyDishesAmount() {
    let result = 0;
    Object.values(orderDishes).filter((o) => !!o.company && o.company.slug === state.selectedCompany).forEach((o) =>
      result += dishesAmount(o.restaurant.slug)
    );
    return result;
  }

  function removeCompany() {
    Object.values(orderDishes).filter((o) => !!o.company).forEach((r) =>
      removeDishes(r.restaurant.slug)
    );
    setState({...state, selectedCompany: false, selectedRestaurant: false})
  }

  return (
    <>
      { dishesCount() > 0 &&
        <>
          <div style={{position: 'relative'}} className="btn-primary nav-icons" onClick={openModal}>
            <Cart/>
            <span className="selected-dishes" style={{
              background: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#F5F5F5' : '#2F2D2A',
              color: !!storeAuth.auth.userData && storeAuth.auth.userData.theme === 'dark' ? '#262626' : '#F5F5F5'}}
            >
              {dishesCount()}
            </span>
          </div>

          { !!orderDishes &&
            <BottomModal
              open={state.busketOrdersModal}
              onDismiss={() => setState({...state, busketOrdersModal: false})}
              header={<h3 className='text-black mb-0'>{t('cart')}</h3>}
            >
              <div className='card'>
                <div className='card-body'>
                  { Object.keys(companies()).length > 0 &&
                    <div className='card position-relative' style={{boxShadow: '0px 2px 12px rgba(29, 10, 3, 0.2)'}}>
                      <Button className='btn-dark position-absolute fs-20' onClick={removeCompany}
                              style={{left: -15, top: -15, padding: '0 7px 4px', borderRadius: 17}}
                      >
                        <Trash height={20} width={20} fill='white'/>
                      </Button>
                      <div className='card-body'>
                        { Object.keys(companies()).length > 0 &&
                          <div className='d-flex align-items-center justify-content-around order-types mb-3'
                             style={{overflowX: 'scroll', whiteSpace: 'nowrap', width: '100%'}}
                          >
                            { Object.values(companies()).map((c, i) =>
                              <div onClick={() => setState({...state, selectedCompany: c.slug,
                                selectedRestaurant: Object.values(orderDishes)
                                .filter((o) => !!o.company && o.company.slug === c.slug)[0].restaurant.slug})}
                                   key={i}
                                   style={{height: '100%', borderRadius: 8, alignItems: 'center', display: 'flex'}}
                                   className={`${state.selectedCompany === c.slug && 'btn-primary'} px-2`}
                              >
                                <h6 className='mb-0' style={{color: state.selectedCompany === c.slug && 'white'}}>
                                  {translateRecord(c, 'name')}
                                </h6>
                              </div>)}
                          </div>}
                        <div className={`d-flex align-items-center order-types mb-3 ${Object.keys(orderDishes).length < 3 && 'justify-content-around'}`}
                             style={{overflowX: 'scroll', whiteSpace: 'nowrap', width: '100%'}}
                        >
                          { Object.values(orderDishes).filter((o) => !!o.company && o.company.slug === state.selectedCompany).map((r, i) =>
                            <div onClick={() => setState({...state, selectedRestaurant: r.restaurant.slug})} key={i}
                                 style={{height: '100%', borderRadius: 8, alignItems: 'center', display: 'flex'}}
                                 className={`${state.selectedRestaurant === r.restaurant.slug && 'btn-primary'} px-2`}
                            >
                              <h6 className='mb-0' style={{color: state.selectedRestaurant === r.restaurant.slug && 'white'}}>
                                {translateRecord(r.restaurant, 'name')}
                              </h6>
                            </div>)}
                        </div>
                        { !!state.selectedRestaurant &&
                          <>
                            {restaurantBusket(state.selectedRestaurant)}
                          </>}
                      </div>
                    </div>}
                  { Object.values(orderDishes).filter((o) => !o.company).map((o,i) => {
                    const slug = o.restaurant.slug;
                    if (!!props.slug ? props.slug === slug : true) {
                      return (
                        <div key={i} className='mb-4 card' style={{boxShadow: '0px 2px 12px rgba(29, 10, 3, 0.2)'}}>
                          { Object.keys(orderDishes[slug]).length > 0 &&
                          <div className='card-body'>
                            { !props.fromDashboard &&
                            <div className='position-relative'>
                              <div className="d-flex justify-content-between align-items-center mb-3">
                                <h3 className='mb-0'>
                                  { isTerminal ?
                                    translateRecord(orderDishes[slug].restaurant, 'name')
                                  :
                                    <Link to={`/r/${slug}`}>
                                      {translateRecord(orderDishes[slug].restaurant, 'name')}
                                    </Link>}
                                </h3>
                                { !orderDishes[slug].restaurant.isSplited && !isTerminal &&
                                <Link className='btn btn-xxs btn-outline-primary' to={`/r/${slug}/menu/${tableId(slug)}`}
                                      onClick={() => setState({...state, busketOrdersModal: false})}
                                      style={{minWidth: 'max-content'}}
                                >
                                  {t('toMenu')}
                                </Link>}
                                <Button className='btn-dark position-absolute fs-20'
                                        style={{left: -30, top: -30, padding: '0 7px 4px', borderRadius: 17}}
                                        onClick={() => removeDishes(slug)}
                                >
                                  <Trash height={20} width={20} fill='white'/>
                                </Button>
                              </div>
                            </div>}
                            { restaurantBusket(slug) }
                          </div>}
                        </div>)}})}
                </div>
              </div>
            </BottomModal>}
        </>}
    </>
  );
};

export default BusketOrders;